module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_101-ecff10e1335ee3bc0ffed18f47949d43.png";